import { PropsWithChildren } from 'react'

import { PLATFORM } from '@/constants/platform'
import { useAuthStore } from '@/stores/useAuthStore'
import { Platform } from '@/types/platform'

type Props = {
  [key in Platform]?: boolean
} & {
  /** Equivalent of passing dge platform (streaming) */
  streaming?: boolean
}

export const PlatformDependent = (props: PropsWithChildren<Props>) => {
  const platform = useAuthStore((state) => state.platform)

  const isStreamingEnabled = !!(props.streaming && platform === PLATFORM.DGE)

  if (!props[platform] && !isStreamingEnabled) {
    return null
  }

  return props.children
}
